import React from 'react';
import './FilterStyles.css';

const VisitorsFilter = ({ filter, onUpdate, onRemove }) => {
  const { percentage = 100 } = filter.values;

  const handlePercentageChange = (e) => {
    const newPercentage = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        percentage: newPercentage
      }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Visitors (Cumulative)</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        <div className="range-display">
          <strong>Show top:</strong> {percentage}% of visitors
        </div>

        <div className="single-range-control">
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            value={percentage}
            onChange={handlePercentageChange}
            className="range-slider"
          />
          <div className="range-value">{percentage}%</div>
        </div>

        <div style={{ fontSize: '0.85rem', color: '#95a5a6', marginTop: '0.5rem', fontStyle: 'italic' }}>
          Shows postcode sectors that account for the first {percentage}% of total visitors.
          At 20%, you'll see the postcodes the first 20% of visitors come from.
        </div>
      </div>
    </div>
  );
};

export default VisitorsFilter;
